import {
  createNavigationContainerRef,
  NavigationContainerRef,
} from '@react-navigation/native';
import {appScreen} from 'constant/appScreen';
import * as React from 'react';
import {CommonActions} from '@react-navigation/native';

export const navigationRef = createNavigationContainerRef();
const timeoutref: any = React.createRef();

export function navigate(
  name: appScreen,
  params?: object,
  cancelDebounce?: boolean,
) {
  return new Promise<void>(resolve => {
    if (__DEV__) {
      console.log('SCREEN:', name);
    }
    navigationRef.current?.navigate(name as any, params);
    resolve();
  });
}

export function goBack() {
  return new Promise((rs, rj) => {
    if (navigationRef.current && navigationRef.current.canGoBack()) {
      navigationRef.current?.goBack();
    }
    rs('');
    return '';
  });
}

export const resetToRootStack = () => {
  navigationRef.current?.dispatch(
    CommonActions.reset({
      index: 0,
      routes: [
        {
          name: 'InvestmentScreen',
        },
      ],
    }),
  );
};
